import _ from 'lodash';

import { LOAN_REQUESTS_ACTION_TYPE } from '../actions/loanRequests.actions';

const initialState = {
  items: [],
  totalCount: 0,
  isLoading: false,
  requestToken: 0,
};

const isStale = (state, token) => !_.isNil(token) && token !== state.requestToken;

const handleSearch = (state, { token }) => ({
  ...state,
  isLoading: true,
  requestToken: token,
});

const handleSearchSuccess = (state, { token, items, totalCount }) =>
  isStale(state, token)
    ? state
    : {
        ...state,
        items,
        totalCount,
        isLoading: false,
      };

const handleSearchFailure = (state, { token }) =>
  isStale(state, token)
    ? state
    : {
        ...state,
        isLoading: false,
      };

const handleReset = () => initialState;

const handlersByType = {
  [LOAN_REQUESTS_ACTION_TYPE.SEARCH]: handleSearch,
  [LOAN_REQUESTS_ACTION_TYPE.SEARCH_SUCCESS]: handleSearchSuccess,
  [LOAN_REQUESTS_ACTION_TYPE.SEARCH_FAILURE]: handleSearchFailure,
  [LOAN_REQUESTS_ACTION_TYPE.RESET]: handleReset,
};

export const loanRequestsReducer = (state = initialState, action = {}) => {
  const handler = _.get(handlersByType, action.type);

  if (!handler) {
    return state;
  }

  return handler(state, action.payload ?? {});
};
